var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZimbabwe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4687 9.16284C29.6558 7.44571 28.5464 5.89677 27.2064 4.58146L16.0001 3.47839L4.79387 4.58152C4.75812 4.61658 4.72324 4.65246 4.68787 4.68789L9.16287 9.1629L16.0001 9.37171L30.4687 9.16284Z",
    fill: "#FFDA44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68762 27.3126C4.7465 27.3715 4.80525 27.4304 4.865 27.4884L16.0001 28.5219L27.135 27.4884C28.4888 26.1759 29.6118 24.6269 30.4361 22.907L9.73912 22.261C7.95831 24.0419 5.90431 26.0958 4.68762 27.3126V27.3126Z",
    fill: "#FFDA44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8408 13.744L13.2173 13.2173L15.9999 16C15.1757 16.8242 13.9453 18.0545 13.2173 18.7826L31.8311 18.3255C31.9417 17.5662 31.9999 16.7899 31.9999 16C31.9999 15.2341 31.9449 14.4812 31.8408 13.744V13.744Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 0C11.6358 0 7.68045 1.74813 4.79382 4.58138H27.2063C24.3197 1.74813 20.3643 0 16.0001 0Z",
    fill: "#6DA544"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.744 13.744H31.8408C31.6125 12.1266 31.1427 10.587 30.4685 9.16266H9.1626L13.744 13.744Z",
    fill: "#D80027"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09314 22.9069H30.4361C31.1183 21.4836 31.5955 19.9438 31.8312 18.3255H13.6745C11.9003 20.0997 10.3967 21.6033 9.09314 22.9069Z",
    fill: "#D80027"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 32C20.3284 32 24.2546 30.2805 27.1349 27.4882H4.86499C7.74524 30.2805 11.6715 32 15.9999 32Z",
    fill: "#6DA544"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71347 3.74579C5.35778 4.04466 5.01459 4.35798 4.68628 4.68616L16 15.9999L4.68628 27.3137C5.01453 27.6419 5.35778 27.9552 5.71347 28.254L17.9676 15.9999L5.71347 3.74579Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43281 11.8262L7.46875 15.0147H10.8216L8.10919 16.9855L9.14519 20.1741L6.43281 18.2034L3.72038 20.1741L4.7565 16.9855L2.04419 15.0147H5.39681L6.43281 11.8262Z",
    fill: "#D80027"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28237 16.2607L6.5825 15.3042C6.5825 15.3042 6.383 13.4328 6.37094 13.3694C6.27931 12.8867 5.85512 12.5216 5.34575 12.5216C4.7695 12.5216 4.30225 12.9888 4.30225 13.5651C4.30225 13.6607 4.31619 13.7527 4.34025 13.8407L3.58325 14.6028H4.92925C4.92925 15.9998 3.88675 15.9998 3.88675 17.3912L4.46506 18.7825H7.94331L8.52306 17.3912H8.52281C8.58087 17.2577 8.61612 17.12 8.63068 16.9824C9.13043 16.7803 9.28237 16.2607 9.28237 16.2607V16.2607Z",
    fill: "#FFDA44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZimbabwe);
export default __webpack_public_path__ + "static/media/zimbabwe.b4385bfd.svg";
export { ForwardRef as ReactComponent };